import {hitAlgolytics} from "@pg-mono/algolytics";

import {getTrackedSiteData} from "./tracked_utils/tracked_site";

export enum FavouritesListCollectionName {
    MY_LIST_COLLECTION = "my_list",
    MY_LIST_OPEN = "my_list_open",
    MY_LIST_BUTTONS = "my_list_buttons",
    MY_LIST_CHECKED = "my_list_checked",
    APPLICATION_OPEN = "application_open",
    COMPARISON_TOOL = "comparison",
    FAVOURITES_MULTILEAD = "favourites_lead_for_all_send"
}

export enum FavouritesListEventTypes {
    FAVOURITES_LIST_MY_LIST_CLICK = "show_my_list",
    FAVOURITES_LIST_APPLIED_LIST_CLICK = "show_my_application",
    FAVOURITES_LIST_RENDER = "my_list_open",
    FAVOURITES_LIST_INTERACTION = "my_list_interaction",
    FAVOURITES_LIST_APPLICATIONS_BUTTON = "my_applications_button_click",
    FAVOURITES_LIST_COMPARISON_TOOL_BUTTON = "comparison_button_click",
    POPUP_DISPLAY = "popup_display"
}

export const handleFavouritesListCheckHit = (checked: boolean, offerId: number, propertyId?: number) => {
    const payload = {
        ...getTrackedSiteData(),
        event_type: FavouritesListEventTypes.FAVOURITES_LIST_INTERACTION,
        offer_id: offerId,
        property_id: propertyId ? propertyId : null,
        checked
    };

    hitAlgolytics(FavouritesListCollectionName.MY_LIST_CHECKED, payload);
};
import {hitAlgolytics} from "@pg-mono/algolytics";

import {getTrackedSiteData} from "./tracked_utils/tracked_site";

export enum FavouritesListCollectionName {
    MY_LIST_COLLECTION = "my_list",
    MY_LIST_OPEN = "my_list_open",
    MY_LIST_BUTTONS = "my_list_buttons",
    MY_LIST_CHECKED = "my_list_checked",
    APPLICATION_OPEN = "application_open",
    COMPARISON_TOOL = "comparison",
    FAVOURITES_MULTILEAD = "favourites_lead_for_all_send"
}

export enum FavouritesListEventTypes {
    FAVOURITES_LIST_MY_LIST_CLICK = "show_my_list",
    FAVOURITES_LIST_APPLIED_LIST_CLICK = "show_my_application",
    FAVOURITES_LIST_RENDER = "my_list_open",
    FAVOURITES_LIST_INTERACTION = "my_list_interaction",
    FAVOURITES_LIST_APPLICATIONS_BUTTON = "my_applications_button_click",
    FAVOURITES_LIST_COMPARISON_TOOL_BUTTON = "comparison_button_click",
    POPUP_DISPLAY = "popup_display"
}

export const handleFavouritesListCheckHit = (checked: boolean, offerId: number, propertyId?: number) => {
    const payload = {
        ...getTrackedSiteData(),
        event_type: FavouritesListEventTypes.FAVOURITES_LIST_INTERACTION,
        offer_id: offerId,
        property_id: propertyId ? propertyId : null,
        checked
    };

    hitAlgolytics(FavouritesListCollectionName.MY_LIST_CHECKED, payload);
};
